import { Component, ChangeDetectionStrategy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Route Logo Spinner Component
 * Displays the animated ANDRITZ logo SVG as a loading indicator
 * with configurable size options (small, mid, large).
 */
@Component({
  selector: 'adf-route-logo-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './route-logo-spinner.component.html',
  styleUrl: './route-logo-spinner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouteLogoSpinnerComponent {
  /**
   * Size of the logo spinner
   * - small: 70px width
   * - mid: 105px width (default)
   * - large: 150px width
   */
  @Input()
  public size: 'small' | 'mid' | 'large' = 'mid';

  private sizeMapWidth = {
    small: 70,
    mid: 105,
    large: 150,
  };

  private sizeMapHeight = {
    small: 14,
    mid: 21,
    large: 30,
  };

  /** Computed width based on size input */
  get width(): number {
    return this.sizeMapWidth[this.size];
  }

  /** Computed height based on size input */
  get height(): number {
    return this.sizeMapHeight[this.size];
  }
}
